import React from "react";

export const Intro = ({ position = "center", children }) => (
  <div className={`intro intro--${position}`}>{children}</div>
);
